class DeliveryMessage extends HTMLElement {
  constructor() {
    super();

    this.deliveryRules = [
      { days: ['maandag', 'dinsdag','woensdag', 'donderdag', 'vrijdag'],
        weekend: false,
        cutoffMorning: window.delivery?.cutoff?.morning || '11:00',
        cutoffAfternoon: window.delivery?.cutoff?.afternoon || '15:00',
        cutoffEvening: window.delivery?.cutoff?.evening || '23:59',
        deliveryNextDay: {
          nl: 'morgen',
          de: 'morgen',
        } },
      {
        days: ['zaterdag', 'zondag'],
        weekend: true,
        cutoffEvening: window.delivery?.cutoff?.evening || '23:59',
        deliveryMonday: {
          nl: 'maandag',
          de: 'Montag',
        },
      },
    ];

    // Detecteer de browsertaal (standaard naar NL als fallback)
    this.language = navigator.language.startsWith('de') ? 'de' : 'nl';

    this.updateDeliveryMessage();

    this.updateInterval = 60000; // 1 minuut
    this.interval = setInterval(() => {
      this.updateDeliveryMessage();
    }, this.updateInterval);
  }

  // Hulpfunctie om tijd (HH:MM) om te zetten naar minuten
  toMinutes(timeStr) {
    let parts = timeStr.split(':');
    return parseInt(parts[0]) * 60 + parseInt(parts[1]);
  }

  updateDeliveryMessage() {
    const now = new Date();
    const currentDay = now.toLocaleDateString(this.language === 'de' ? 'de-DE' : 'nl-NL', { weekday: 'long' }).toLowerCase();
    const currentTime = now.getHours() * 60 + now.getMinutes();
    const currentSeconds = now.getSeconds();

    let message = ''; // Standaard lege boodschap

    for (let rule of this.deliveryRules) {
      if (rule.days.includes(currentDay)) {
        if (rule.cutoffMorning && currentTime < this.toMinutes(rule.cutoffMorning)) {
          this.updateInterval = 1000; // 1 seconde voor countdown

          if (window.delivery?.text?.same_day_delivery_countdown !== '') {
            let remainingSeconds = (this.toMinutes(rule.cutoffMorning) * 60) - (currentTime * 60 + currentSeconds);

            if (remainingSeconds > 0) {
              let hours = Math.floor(remainingSeconds / 3600);
              let minutes = Math.floor((remainingSeconds % 3600) / 60);
              let seconds = remainingSeconds % 60;

              let countdownText = '';

              if (hours > 0) {
                countdownText += `${hours} ${hours === 1 ? (this.language === 'de' ? 'Stunde' : 'uur') : (this.language === 'de' ? 'Stunden' : 'uur')}${(minutes > 0) ? ',' : ' en'} `;
              }
              if (minutes > 0) {
                countdownText += `${minutes} ${minutes === 1 ? (this.language === 'de' ? 'Minute' : 'minuut') : (this.language === 'de' ? 'Minuten' : 'minuten')} en `;
              }
              countdownText += `${seconds} ${seconds === 1 ? (this.language === 'de' ? 'Sekunde' : 'seconde') : (this.language === 'de' ? 'Sekunden' : 'seconden')}`;

              message = window.delivery?.text?.same_day_delivery_countdown?.replace('[[countdown]]', countdownText) || '';
            }
          }
          else {
            message = window.delivery?.text?.same_day_delivery
              ?.replace('[[cutoff]]', rule.cutoffMorning);
          }
          break;
        }
        if (rule.cutoffAfternoon && currentTime < this.toMinutes(rule.cutoffAfternoon)) {
          message = window.delivery?.text?.daglevering
            ?.replace('[[cutoff]]', rule.cutoffAfternoon)
            ?.replace('[[delivery_day]]', rule.deliveryNextDay[this.language]);
          break;
        }
        if (rule.cutoffEvening && currentTime <= this.toMinutes(rule.cutoffEvening)) {
          if (rule.weekend) {
            message = window.delivery?.text?.weekend
              ?.replace('[[cutoff]]', rule.cutoffEvening)
              ?.replace('[[delivery_day]]', rule.deliveryMonday[this.language]);
          }
          else {
            message = window.delivery?.text?.avondlevering
              ?.replace('[[cutoff]]', rule.cutoffEvening)
              ?.replace('[[delivery_day]]', rule.deliveryNextDay[this.language]);
          }
          break;
        }
      }
    }

    this.updateIntervalFunc();

    if (this.message !== message) {
      this.message = message;
      this.innerHTML = this.message; // Update de HTML alleen als de boodschap verandert
    }
  }

  updateIntervalFunc() {
    clearInterval(this.interval);

    this.interval = setInterval(() => {
      this.updateDeliveryMessage();
    }, this.updateInterval);
  }
}

if (!customElements.get('delivery-message')) {
  customElements.define('delivery-message', DeliveryMessage);
}